import { render } from "./Prompts.vue?vue&type=template&id=e053c12e&scoped=true&ts=true"
import script from "./Prompts.vue?vue&type=script&lang=ts"
export * from "./Prompts.vue?vue&type=script&lang=ts"

import "./Prompts.vue?vue&type=style&index=0&id=e053c12e&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e053c12e"]])

export default __exports__